import React from 'react';
import PropTypes from 'prop-types';
import {i18n, formatDate, formatTime} from '../../Utility/Format';
import { connect } from 'react-redux';
import { selectors } from '../../Redux/index';
import moment from 'moment';

/**
 * Displays a container with a message send by the server when the data was last updated.
 * Usually below a table.
 */
const LastUpdateMessage = ({ date, message, hint, noData, locale = 'en' }) => {
    const dateFormatted = formatDate(date, locale);
    const timeFormatted = formatTime(date);
    const timezone = moment(date).format('Z');

    return (
        <div className="last-update-message">
            {
                message ? <span>{message}</span> :
                    date ?
                        <span>
                            {i18n('dbm.table.lastUpdate')} {dateFormatted} - {timeFormatted} GMT{timezone}
                        </span> :
                        i18n(noData ? 'dbm.table.emptyData' : 'dbm.table.loadingData')
            }
            {
                hint ? <div className="rightHint">{hint}</div> : null
            }
        </div>
    );
};

LastUpdateMessage.propTypes = {

    date: PropTypes.string,

    /**
     * If message is passed, date will be ignored and message displayed instead
     */
    message: PropTypes.string,
    locale: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        locale: selectors.UI.Locale.getLocale(state)
    };
};

export default connect(mapStateToProps)(LastUpdateMessage);